package com.ives.modules.tags;

import com.er453r.hxcompo.Component;

class TagsRow extends Component {
	public function new(tag:String, value:String, ae:String) {
		this.tag.innerHTML = tag;
		this.value.innerHTML = value;
		this.ae.innerHTML = ae;
	}
}
